import React from 'react';
import styled from 'styled-components';

import IconTooltip from '@rover/components/src/callouts/IconTooltip';
import { PopoverPlacement } from '@rover/components/src/callouts/Popover';
import CheckBox from '@rover/components/src/formFields/Checkbox';
import MQ from '@rover/kibble/styles/MediaQuery';

export type Props = {
  label: string;
  tooltip: string;
  onChange: (isChecked: boolean, value: any | null | undefined) => void;
  checked: boolean;
  value?: any;
  onTooltipHover?: () => void;
};

const StyledDiv = styled.div`
  margin-bottom: 10px;
`;

const StyledLabel = styled.label`
  display: inline-block;
`;

const StyledSpan = styled.span`
  display: inline;
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  margin-left: 10px;
  margin-right: 5px;

  ${MQ.SM_UP.toString()} {
    padding-bottom: ${({ theme }) => theme.space['2x']};
  }
`;

const CheckBoxOption = ({
  label,
  tooltip,
  onChange,
  checked,
  value,
  onTooltipHover,
}: Props): JSX.Element => {
  return (
    <StyledDiv>
      <StyledLabel>
        <CheckBox checked={checked} onChange={onChange} value={value} />
        <StyledSpan>{label}</StyledSpan>
        {tooltip && ( // preventDefault here avoids the issue where tapping the tooltip selects the checkbox
          // the following lints are ignorable since we are just catching an event here
          /* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
          <span
            onClick={(e) => e.preventDefault()}
            onMouseEnter={() => onTooltipHover && onTooltipHover()}
          >
            <IconTooltip text={tooltip} placement={PopoverPlacement.BOTTOM} />
          </span>
        )}
      </StyledLabel>
    </StyledDiv>
  );
};

export default CheckBoxOption;
